<script>
import api from '@/api'
import { alertSuccess } from '@/helpers/swal'

export default {
  data() {
    return {
      pagetitle: 'Devices',
      credentials: [],
      categories: [],
      deviceTypes: [],
      bulk: {
        credentialId: '',
        categoryId: '',
        deviceTypeId: '',
        file: null
      },
      errors: {}
    }
  },
  async mounted() {
    await this.getCredentials()
    await this.getCategories()
    await this.getDeviceTypes()
  },
  methods: {
    async getCredentials() {
      const params = { size: 100 }
      const response = await api.get('/credentials/getCredentials', { params })
      this.credentials = response.data?.content || []
    },
    async getCategories() {
      const response = await api.get(`${window.apiUrl}/category/getCategories`)
      this.categories = response.data
    },
    async getDeviceTypes() {
      const response = await api.get('/device-types/list')
      this.deviceTypes = response.data.deviceTypes
    },
    onFileChange(e) {
      this.bulk.file = e.target.files[0]
    },
    async uploadBulk() {
      if (!this.validateRequest()) return

      const formData = new FormData()
      formData.append('file', this.bulk.file)
      formData.append('categoryId', this.bulk.categoryId)
      formData.append('deviceTypeId', this.bulk.deviceTypeId)
      formData.append('credentialId', this.bulk.credentialId)

      try {
        const response = await api.post('/devices/add/bulk', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
        });
        alertSuccess(response.data); 
        this.$router.push({ name: 'devices' });
      } catch (error) {
        alert(error.response?.data?.message || 'Failed to upload devices');
    }
    },
    validateRequest() {
      this.errors = {}
      if (!this.bulk.file) this.errors.file = 'CSV file is required'
      if (!this.bulk.categoryId) this.errors.categoryId = 'Category is required'
      if (!this.bulk.deviceTypeId) this.errors.deviceTypeId = 'Device type is required'
      if (!this.bulk.credentialId) this.errors.credentialId = 'Credential is required'
      return Object.keys(this.errors).length === 0
    }
  }
}
</script>

<template>
  <div class="row">
    <div class="col-xl-6">
      <Teleport to="#elePageTitle">
        {{ pagetitle }}
      </Teleport>
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Bulk Upload Devices</h4>
        </div>
        <div class="card-body">
          <form @submit.prevent="uploadBulk">
            <div class="mb-3">
              <label class="form-label">Credentials</label>
              <select v-model="bulk.credentialId" class="form-select">
                <option value="">Select</option>
                <option v-for="c in credentials" :key="c.id" :value="c.id">{{ c.profileName }}</option>
              </select>
              <div v-if="errors.credentialId" class="invalid-feedback">{{ errors.credentialId }}</div>
            </div>
            <div class="mb-3">
              <label class="form-label">Category</label>
              <select v-model="bulk.categoryId" class="form-select">
                <option value="">Select</option>
                <option v-for="cat in categories" :key="cat.id" :value="cat.id">{{ cat.categoryName }}</option>
              </select>
              <div v-if="errors.categoryId" class="invalid-feedback">{{ errors.categoryId }}</div>
            </div>
            <div class="mb-3">
              <label class="form-label">Device Type</label>
              <select v-model="bulk.deviceTypeId" class="form-select">
                <option value="">Select</option>
                <option v-for="t in deviceTypes" :key="t.id" :value="t.id">{{ t.deviceType }}</option>
              </select>
              <div v-if="errors.deviceTypeId" class="invalid-feedback">{{ errors.deviceTypeId }}</div>
            </div>
            <div class="mb-3">
              <label class="form-label">CSV File</label>
              <input type="file" class="form-control" accept=".csv" @change="onFileChange" />
              <div class="form-text">Include a <code>Host</code> column (required). Optional <code>IpAddress</code> is supported.</div>
              <div v-if="errors.file" class="invalid-feedback">{{ errors.file }}</div>
            </div>
            <button type="submit" class="btn btn-success">Upload</button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>